import { render } from "./FormCaption.vue?vue&type=template&id=67f8fd8f"
import script from "./FormCaption.vue?vue&type=script&lang=js"
export * from "./FormCaption.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__